import React, { Suspense } from 'react';
const ObjectEditor = /*#__PURE__*/React.lazy(() => import("./ObjectEditor.js"));
function LazyObjectEditor(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
  }, /*#__PURE__*/React.createElement(ObjectEditor, props));
}
const type = 'object';
export default {
  type,
  editor: LazyObjectEditor
};